import { render, staticRenderFns } from "./CarIcon.vue?vue&type=template&id=6805c5bb&"
import script from "./CarIcon.vue?vue&type=script&lang=js&"
export * from "./CarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports